import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserService } from '../../../../_services/user.service';
import { ValidateEmailService } from '../../../../_services/signup-process-service/validate-email.service';
import { AlertService, AcmicService } from '@mapfre-design-library/src/public_api';
import { ErrorRedirectionService } from '../../../../_services/error-service/error-redirection.service';
import { Router , RouterModule } from '@angular/router';
import { Location } from '@angular/common';
import { EmailService } from '@services/email/email.service';
import { Meta } from '@angular/platform-browser';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreButtonComponent],
  selector: 'app-validate-account',
  templateUrl: './validate-account.component.html',
  styleUrls: ['./validate-account.component.scss'],
})
export class ValidateAccountComponent implements OnInit, OnDestroy {
  email: any;
  user_detail: any = [];
  phoneNum;
  addTopMargin = false;
  isEmailEntered = false;
  isEmailChanged = false;
  isAcmic = false;
  newEmail: string;
  oldEmail: string;
  constructor(
    private _userService: UserService,
    private alertService: AlertService,
    private validateEmailService: ValidateEmailService,
    private errorRedirectionService: ErrorRedirectionService,
    private router: Router,
    private acmicService: AcmicService,
    private location: Location,
    private emailService: EmailService,
    private meta: Meta
  ) {}

  ngOnInit(): void {
    this.meta.addTag({ name: 'robots', content: 'noindex' });
    this.user_detail = this._userService.getUserInfoInStorage();
    this.isAcmic = this.acmicService.isACMIC();
    this.oldEmail = this.user_detail.userDetails['email'];
    this.newEmail = this.user_detail.userDetails['newEmail'];
    if (this.oldEmail) {
      this.oldEmail = this.oldEmail.trim().toLowerCase();
    }
    if (this.oldEmail && this.newEmail && this.newEmail !== this.oldEmail) {
      this.isEmailChanged = true;
    }
    if (this.user_detail) {
      this.isEmailEntered = this.user_detail['userDetails']['isEmailEntered'];
      if (!this.isEmailEntered) {
        this.email = this.emailService.maskEmail(this.user_detail['userDetails']['email']);
      } else {
        this.email = this.user_detail['userDetails']['newEmail'];
      }
      this.phoneNum = this.user_detail['userDetails']['phone'];
    }
  }
  sendEmail() {
    if (!this.newEmail) {
      this.newEmail = this.oldEmail;
    }
    // Call sendValidationEmail for send Resent Verification mail form user email address
    this.validateEmailService
      .sendValidationEmailForNonCommercial(
        this.newEmail,
        this.oldEmail,
        this.isEmailChanged
      )
      .subscribe(
        () => {
          this.alertService.success('NEW_VERIFICATION_EMAIL_SENT');
          this.addTopMargin = true;
        },
        (error) => {
          this.errorRedirectionService.errorHandler(
            error,
            'VERIFICATION_EMAIL_ERROR'
          );
        }
      );
  }

  resendEmail(){
    if (!this.newEmail) {
      this.newEmail = this.oldEmail;
    }
    this.validateEmailService.sendValidationEmail(this.newEmail).subscribe(
      () => {
        this.alertService.success('NEW_VERIFICATION_EMAIL_SENT');
        this.addTopMargin = true;
      },
      (error) => {
        this.errorRedirectionService.errorHandler(
          error,
          'VERIFICATION_EMAIL_ERROR'
        );
      }
    );;
  }

  backToConfirmEmail(): void {
    this.router.navigate(['/signup', 'confirm-email']);
  }

  goBack(): void {
    this.location.back();
  }

  ngOnDestroy(): void {
    this.meta.removeTag('name="robots"');
  }
}
